import Markdown from "./Markdown";
import Metadata from "./Metadata";
import RecentActivity from "./RecentActivity";
import Resources from "./Resources";
import TableOfContents from "./TableOfContents";
import Texts from "./Texts";

export default {
  Markdown,
  Metadata,
  RecentActivity,
  Resources,
  TableOfContents,
  Texts
};
